import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import moment from 'moment';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { TravelDetail } from 'Components/widgets/travel-details/travel-detail/TravelDetail';
type Props = {
  className?: string;
  departureDate: string;
  returnDate: string;
};
export const DurationTravelDetails = ({ className, departureDate, returnDate }: Props) =>
  departureDate && returnDate ? (
    <TravelDetail
      {...asWidgetProps<ComponentProps<typeof TravelDetail>>({
        className: className,
        icon: ICONS.DATE,
        infos: {
          text1: t('common.duration.from'),
          highlightText1: moment(departureDate, API_DATE_FORMAT).format(t('stays.dateFormat')),
          text2: t('common.duration.to'),
          highlightText2: moment(returnDate, API_DATE_FORMAT).format(t('stays.dateFormat')),
        },
      })}
    />
  ) : null;
